import React from 'react';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';

class RenameAssetModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            title: props.asset.title,
        };
    }

    onTitleChange = e => {
        this.setState({ title: e.target.value });
    };

    onTitleUpdate = e => {
        if (e && e.key === 'Enter') {
            const { title } = this.state;
            if (title !== '') {
                this.onUpdate();
            }
        }
    };

    onUpdate = () => {
        const { title } = this.state;
        const { asset } = this.props;

        this.props.onUpdate(asset, title);

        this.props.onClose();
    };

    render() {
        const { show, classes, onClose } = this.props;

        if (!show) {
            return null;
        }

        const { title } = this.state;

        return (
            <React.Fragment>
                <Dialog open={true} onClose={onClose}>
                    <DialogTitle>Edit Asset Title</DialogTitle>
                    <DialogContent>
                        <div className={classes.content}>
                            <TextField
                                required
                                label="Asset title"
                                onChange={this.onTitleChange}
                                onKeyPress={this.onTitleUpdate}
                                value={title}
                            />
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onClose}>CANCEL</Button>

                        <Button
                            onClick={this.onUpdate}
                            color="primary"
                            variant="contained"
                            disabled={title.length === 0}
                        >
                            UPDATE ASSET
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

RenameAssetModal.propTypes = {
    show: PropTypes.bool.isRequired,
    asset: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
};

RenameAssetModal.defaultProps = {
    show: false,
};

const style = () => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
});

export default injectSheet(style)(RenameAssetModal);



// WEBPACK FOOTER //
// ./src/components/modals/RenameAssetModal.js